function CaravanTriggerGoalTransformer(jsonMapper, util, quoteOptions) {
	function transform(userInput) {
		var policyHolder = userInput.policyHolders[0];
		var address = userInput.policyAddress;
		
		var request = {
			Email:  policyHolder.contact.emailAddress1,
			FirstName: policyHolder.contact.firstName,
			LastName: policyHolder.contact.lastName,
			AddressLine: address.addressLine1,
			City: address.city,
			State: address.state,
			PostCode: address.postalCode,
			CountryCode: "Australia",
			Product: "Caravan",
			UserAgent: "SPA-Caravan"
		};
		return request;
	}

	return {
		transform: transform
	}
}
